module.exports = __webpack_public_path__ + "static/media/vip-tab-active.2e03de60.png";